import styled from 'styled-components';
import PrimaryButton from 'Common/components/Controls/Buttons/PrimaryButton';

export const ActionButton = styled(PrimaryButton)`
  width: 176px;
  margin-top: auto;
`;
